import Phaser from "phaser";

export default class WinsContainer extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, wins) { //wins ranges from 0-3 (inclusive)
        super(scene, x, y, 'all_images', 'wins');
        this.scale = scale;
        this.updateWins(wins);
    }

    updateWins(wins) {
        if (!this.win1 && wins >= 1) {
            this.win1 = this.scene.add.image(this.x, this.y - (92*this.scale), 'all_images', 'win_marker').setScale(this.scale).setDepth(this.depth + 1);
        }
        else if (this.win1 && wins < 1) {
            this.win1.destroy();
            this.win1 = null;
        }

        if (!this.win2 && wins >= 2) {
            this.win2 = this.scene.add.image(this.x, this.y, 'all_images', 'win_marker').setScale(this.scale).setDepth(this.depth + 1);
        }
        else if (this.win2 && wins < 2) {
            this.win2.destroy();
            this.win2 = null;
        }

        if (!this.win3 && wins >= 3) {
            this.win3 = this.scene.add.image(this.x, this.y + (92*this.scale), 'all_images', 'win_marker').setScale(this.scale).setDepth(this.depth + 1);
        }
        else if (this.win3 && wins < 3) {
            this.win3.destroy();
            this.win3 = null;
        }
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("winsContainer", function (x, y, texture, scale, wins) {
    const winsContainerInst = new WinsContainer(this.scene, x, y, texture, scale, wins);

    this.displayList.add(winsContainerInst);
    this.updateList.add(winsContainerInst);

    return winsContainerInst;
})